module.exports = __webpack_public_path__ + "c2eeb33e5fd5f747abb2fba54c048892.png";